import React, { Component } from 'react';
import { connect } from "react-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';

import ParamsIcon from "../../img/icons/MKT-parametry";
import SipkaIcon from "../../img/icons/BBiconsRozbalit";
import UdajeIcon from "../../img/icons/MKT-udaje";

import "./navigator.scss";

class Navigator extends Component {
    render() {
        return (
            <div className="mkt-navigator">
                <div onClick={() => this.activeStep === 2 && this.submit()} className={`item ${this.props.match.url.match(/\/unicorn\/\w+\/parameters/) ? "active" : "disabled"}`}>
                    <div className="icn"><ParamsIcon /></div>
                    <div className="text">1.&nbsp;<Translate id="MarketingList.Criteria" /></div>
                    <div className="text text-desc"><Translate id="MarketingList.Criteria.Description" /></div>
                </div>
                <div className={`arrow ${this.stepClass}`}>
                    <SipkaIcon />
                </div>
                <div onClick={() => this.canContinue && this.activeStep === 1 && this.submit()} className={`item  ${this.props.match.url.match(/\/unicorn\/\w+\/configuration/) ? "active" :  "disabled" }`}>
                    <div className="icn"><UdajeIcon /></div>
                    <div className="text">2.&nbsp;<Translate id="Common.Choose.Data" /></div>
                    <div className="text text-desc"><Translate id="MarketingList.Choose.Data.Description" /></div>
                </div>
            </div>
        )
    }
    submit() {
        if (this.activeStep === 2) {
            document.querySelector("#fake-submit-config").setAttribute("data-redirect", "params");
        }
        this.activeStep === 1 ? document.querySelector("#fake-submit-params").click() : document.querySelector("#fake-submit-config").click();
    }
    get activeStep() {
        return this.props.match.url.match(/\/unicorn\/\w+\/parameters/) ? 1 : 2;
    }
    get canContinue() {
        //check all flags except excel file
        return Object.keys(this.props.sections).map(x => this.props.sections[x]).filter(s => s.hasOwnProperty("checked")).filter(x => x.checked).length > 0 || this.props.sections.xlsFileContent.fileName !== "";
    }
    get requestId() {
        if (!isNullOrUndefined(this.props.location.state) && !isNullOrUndefined(this.props.location.state.requestId)) {
            return this.props.location.state.requestId;
        }
        return null;
    }
    get configId() {
        if (!isNullOrUndefined(this.props.location.state) && !isNullOrUndefined(this.props.location.state.configId)) {
            return this.props.location.state.configId;
        }
        return null;
    }
    get stepClass() {
        return "disabled";
    }
}


export default withLocalize(withRouter(connect(
    state => state.marketingList
)(Navigator)));
